import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
import { type Description } from "@components/description/_types/description.types";
import useParameters from "../../app/parameters/useParameter";

function isEmpty(string: string) {
  return string.includes("None") || string.includes("Geen");
}

interface DescriptionTextProps {
  descriptions: Description[];
  noInfo: string;
}

export default function DescriptionText({
  descriptions,
  noInfo
}: DescriptionTextProps) {
  const { i18n } = useTranslation();

  const description = descriptions.find(
    (description_) => description_.language === i18n.language.toUpperCase()
  );

  if (description && description.text && !isEmpty(description.text)) {
    return <Render text={description.text} />;
  } else {
    const alternative = descriptions.find(
      (description_) => description_.language !== i18n.language.toUpperCase()
    );

    if (alternative && alternative.text && !isEmpty(alternative.text)) {
      return <Render text={alternative.text} noInfo={noInfo} />;
    }
  }

  return null;
}

export function Render({ text, noInfo }: { text: string; noInfo?: string }) {
  const parameters = useParameters();
  const markdown = (parameters["description.format"] || "html") === "markdown";

  return (
    <>
      {noInfo && (
        <p>
          <i>{noInfo}</i>
        </p>
      )}
      {markdown ? <Markdown>{text}</Markdown> : <span>{parse(text)}</span>}
    </>
  );
}
